/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageTimingEditModalController', function($uibModalInstance, pkgTiming) {
	var self = this;
	self.timingTypes = ['Program Start/End', 'Commercial Black'];
	self.selectedTiming = pkgTiming || {
			description: 'Program Start/End',
			startTC: '00:00:00:00',
			endTC: '00:00:00:00',
			durationTC: '00:00:00:00'
		};
	self.selectedTimingType = (pkgTiming && pkgTiming.description === 'Commercial Black')? 'Commercial Black' : 'Program Start/End';

	self.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	};

	self.onOk = function () {
		self.selectedTiming.description = self.selectedTimingType;
		$uibModalInstance.close(self.selectedTiming);
	};

	self.disableOk = function () {
		return self.selectedTiming.startTC === '00:00:00:00' || self.selectedTiming.endTC === '00:00:00:00' ||
			self.selectedTiming.endTC < self.selectedTiming.startTC;
	};
});
